export default __webpack_public_path__ + "54957e60ca7bc7addf5b8ab2a4691d46.jpg";